<template>
  <div class="fixed-container">
    <div class="c" @click="clickType()">
      <img src="@/assets/home/kstx.png" />
      <div>测评题型</div>
    </div>
    <div class="c second">
      <img src="@/assets/home/lxwm.png" />
      <div>测评报名</div>
      <transition name="fade"
        ><div class="tip">
          <img src="@/assets/home/tip_bg.png" />
          <div class="title">CNSET考委会办公室</div>
          <div class="des">
咨询服务电话：400-018-5055<br/>
通讯地址：北京市海淀区车公庄西路甲19号国际传播大厦八层801<br/>
分级测评官网：<a href="https://www.cnset.com.cn">https://www.cnset.com.cn</a><br/>
微信公众平台：CNSET
          </div>
        </div>
      </transition>
    </div>
    <div class="c" @click="clickProblem()">
      <img src="@/assets/home/cjwt.png" />
      <div>平台使用说明</div>
    </div>
    <div class="c second">
      <img src="@/assets/home/guanzhuwomen.png" />
      <div>关注我们</div>
      <transition name="fade"
        ><div class="tip2">
          <img src="@/assets/home/tip_bg2.png" />
          <!-- <img style="position:relative;left:100px;top:-200px;" src="@/assets/home/wxpub.png" /> -->
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  //  methods: {
  //   clickTab() {
  //     console.log(111);
  //   }
  // }
  methods: {
    clickType() {
      //this.$router.push({ name: "examinationtype" });
       window.open("https://www.cnset.com.cn/material/题型说明.pdf");
    },
    clickProblem() {
      // let routeUrl = this.$router.resolve({
      //   path: "/problem"
      // });
      window.open("https://www.cnset.com.cn/material/平台使用说明.pdf", "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.fixed-container {
  position: fixed;
  cursor: pointer;
  width: 101px;
  // left: 1230px;
  right: 130px;
  top: 284px;
  background-color: white;
  border-radius: 8px;
  z-index: 99;
  border: solid 1px #000b3c22;
  .c {
    text-align: center;
    padding: 10px 0;
    div {
      font-size: 12px;
      color: #344f97;
    }
  }
  .second {
    position: relative;
    .tip {
      position: absolute;
      width: 443px;
      height: 250px;
      left: -480px;
      top: -150px;
      display: none;
      // background-image: url("@/assets/home/tip_bg.png");
      // background-image:
      .title {
        position: absolute;
        top: 70px;
        left: 60px;
        font-size: 18px;
        color: #344f97;
        font-weight: bolder;
      }
      .des {
        position: absolute;
        color: #333333;
        // opacity: 0.4;
        top: 100px;
        left: 60px;
        font-size: 16px;
        text-align: left;
      }
    }
    &:hover .tip {
      display: block;
    }
    .tip2 {
      position: absolute;
      width: 269px;
      height: 276px;
      left: -268px;
      top: -150px;
      display: none;
      
    }
    &:hover .tip2 {
      display: block;
      // background-image:
    }
  }

  .c:nth-child(odd) {
    border-bottom: solid 1px #000b3c22;
    border-top: solid 1px #000b3c22;
  }
}
</style>
